"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes@0.4.6";

export function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <NextThemesProvider
      attribute="data-theme"
      defaultTheme="dark"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="bbb_theme"
    >
      {children}
    </NextThemesProvider>
  );
}
